import { render, staticRenderFns } from "./CompensationProgram.vue?vue&type=template&id=142da1fc&"
import script from "./CompensationProgram.vue?vue&type=script&lang=ts&"
export * from "./CompensationProgram.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports